import React, { Fragment } from 'react'
import get from 'lodash/fp/get'

import { FINANCIAL_TYPES_VALUES } from '../../constants'

import { FormattedMessage } from '@dragonraider5/react-intl'
import { showFieldError, renderValidation } from '../../../../../utils/validations'

import SelectField from '../../../../../components/FormFields/SelectField'
import FormRow from '../../../../../components/FormFields/FormRow'
import TextField from '../../../../../components/FormFields/TextField'
/* eslint-disable-next-line */
import FieldMonths from '../../../../../components/FormFields/FieldMonths'
import valueMessages from './valueMessages'

function SolicitudeFields({
  values,
  errors,
  touched,
  setFieldValue,
  handleChange,
  handleBlur,
  namePrefix=''
}) {
  const financialTypeName = `${namePrefix}finnancial_type`
  const howMuchTypeName = `${namePrefix}how_much`
  const howMuchTimeMonthsName = `${namePrefix}how_much_time_months`
  const financialTypeValue = get(financialTypeName)(values)

  const makeOnNumberValueChange = name => values => setFieldValue(name, values.floatValue)

  return (
    <Fragment>
      <FormRow>
        <SelectField
          name={financialTypeName}
          value={financialTypeValue}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError(financialTypeName, { errors, touched })}
          help={renderValidation(financialTypeName, { errors, touched })}
          label='Tipo de financiación'
          full
        >
          <option value='' />
          {Object.values(FINANCIAL_TYPES_VALUES).map(value => (
            <FormattedMessage key={value} {...valueMessages[`financialTypes${value}`]}>
              {message => <option value={value}>{message}</option>}
            </FormattedMessage>
          ))}
        </SelectField>
      </FormRow>
      <FormRow>
        <TextField
          type='numeric'
          name={howMuchTypeName}
          value={get(howMuchTypeName)(values)}
          onValueChange={makeOnNumberValueChange(howMuchTypeName)}
          onBlur={handleBlur}
          error={showFieldError(howMuchTypeName, { errors, touched })}
          help={renderValidation(howMuchTypeName, { errors, touched })}
          label='¿Cuánto necesitas?'
          suffix='€'
          thousandSeparator='.'
          decimalSeparator=','
          allowNegative={false}
          full
        />
      </FormRow>
      {parseInt(financialTypeValue, 10) !== FINANCIAL_TYPES_VALUES.avales && (
        <FormRow>
          <TextField
            type='numeric'
            name={howMuchTimeMonthsName}
            value={get(howMuchTimeMonthsName)(values)}
            onValueChange={makeOnNumberValueChange(howMuchTimeMonthsName, { setFieldValue })}
            onBlur={handleBlur}
            error={showFieldError(howMuchTimeMonthsName, { errors, touched })}
            help={renderValidation(howMuchTimeMonthsName, { errors, touched })}
            label='¿En cuánto tiempo quieres devolverlo?'
            suffix='meses'
            thousandSeparator='.'
            decimalSeparator=','
            allowNegative={false}
            tip={financialTypeValue !== '' && (
              <FormattedMessage
                {...valueMessages.howMuchTimeMonthsTip}
                values={{
                  productType: financialTypeValue,
                  productTypeName: (
                    <FormattedMessage {...valueMessages[`financialTypes${financialTypeValue}`]}>
                      {value => value.toLowerCase()}
                    </FormattedMessage>
                  )
                }}
              />
            )}
            full
          />
        </FormRow>
      )}
    </Fragment>
  )
}

export default SolicitudeFields
